import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';

const OrgRoute: React.FC = () => {
  const { user } = useUser();

  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const role = (user.Role || user.role || '').toLowerCase();
  const isOrg = role === 'org admin' || role === 'org rep';

  if (!isOrg) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default OrgRoute;
